
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatUrlForDisplay(url: string, maxLength: number = 40): string {
  if (!url) return url;
  
  // Remove protocol (http:// or https://)
  let displayUrl = url.replace(/^https?:\/\//, '');
  
  // Trim to maxLength if needed
  if (displayUrl.length > maxLength) {
    displayUrl = displayUrl.substring(0, maxLength) + '...';
  }
  
  return displayUrl;
}
